export default __webpack_public_path__ + "static/Everyelsewhere EP poster text-87869c6a0982787101b9f8e228a3bba3.jpg";